import type { ClassData, LibraryData } from '@/core/types/library.type'

import { findClassDataByType } from './findClassDataByType'

type ResolveClassDataParams = {
  runtimeTypeName: string | null
  hintTypeName?: string
  libraries: Record<string, LibraryData>
  fallbackClassData?: ClassData
}

export function resolveClassDataForType({
  runtimeTypeName,
  hintTypeName,
  libraries,
  fallbackClassData,
}: ResolveClassDataParams): ClassData | undefined {
  const fromRuntime = runtimeTypeName ? findClassDataByType(runtimeTypeName, libraries) : undefined
  const fromHint = hintTypeName ? findClassDataByType(hintTypeName, libraries) : undefined

  if (fromHint && fromRuntime && fromHint.name !== fromRuntime.name) {
    return fromHint
  }

  if (fromRuntime) return fromRuntime
  if (fromHint) return fromHint
  return fallbackClassData
}
